import Seo from "@/components/Seo";
import SectionHeader from "@/components/SectionHeader";
import ServiceCard from "@/components/ServiceCard";
import ProcessSection from "@/sections/ProcessSection";
import CTASection from "@/components/CTASection";
import Reveal from "@/components/Reveal";
import { SERVICES } from "@/lib/content";

const Services = () => (
  <>
    <Seo
      title="Our Services | Kryvo Technologies"
      description="Websites, web applications, AI MVPs and mobile applications — modern digital solutions designed and built around your business goals."
    />
    <section className="grid-bg bg-kryvo-mist pb-16 pt-[calc(72px+4rem)] sm:pb-20" data-testid="services-hero">
      <div className="container-x">
        <SectionHeader
          eyebrow="Our Services"
          title="Technology Solutions for Your Business"
          description="We design and build modern digital solutions that help businesses launch faster, work smarter and grow stronger."
        />
      </div>
    </section>

    <section className="container-x py-16 sm:py-20" data-testid="services-grid">
      <div className="grid gap-6 sm:grid-cols-2">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={i * 0.08}>
            <div className="h-full">
              <ServiceCard service={s} />
              <ul className="mx-7 -mt-2 mb-2 flex flex-wrap gap-2">
                {s.whatWeBuild.slice(0, 3).map((w) => (
                  <li key={w} className="rounded-full bg-kryvo-mist px-3 py-1 text-xs text-kryvo-ink/60">
                    {w}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </section>

    <ProcessSection />
    <CTASection />
  </>
);

export default Services;
